import ready from '../utils/ready';

const infoBannerKey = 'info-banner';

const initializeInfoBanner = () => {
  const infoBanner = document.getElementById('info-banner');
  if (infoBanner) {
    const hasClosed = sessionStorage.getItem(infoBannerKey);
    if (!hasClosed) {
      document.getElementById('info-banner-close')?.addEventListener('click', () => {
        sessionStorage.setItem(infoBannerKey, 'true');
        infoBanner.setAttribute('hidden', '');
      });
      infoBanner.removeAttribute('hidden');
    }
  }
};

ready(initializeInfoBanner);
